export function getDisableIconClasses(disabled?: boolean) {
  return disabled ? 'cursor-not-allowed text-gray-300' : 'text-primary-700';
}
